import React from 'react';

/**
 * SectionCard — one titled block of the profile form (Main, Contacts,
 * Emergency contact, General pilot time).
 *
 * Deliberately not a HeroUI `Card`: the Pencil design puts the icon and the
 * title on one baseline with no divider under them, and Card's slot padding
 * fights that. A plain frame with the page's own tokens is less code and
 * matches RolesUsers-V2's panels.
 */
function SectionCard({ icon: Icon, title, children }) {
	return (
		<section className="bg-content1 border border-default-200 rounded-xl p-4 sm:p-5">
			<header className="flex items-center gap-2.5 mb-4">
				{/* Brand-blue badge, the page header's badge at section scale. */}
				{Icon ? (
					<span className="w-7 h-7 shrink-0 rounded-lg bg-primary-500/10 flex items-center justify-center">
						<Icon className="w-4 h-4 text-primary-600" aria-hidden="true" />
					</span>
				) : null}
				<h2 className="m-0">
					<span className="text-[15px] font-semibold text-foreground">{title}</span>
				</h2>
			</header>
			{children}
		</section>
	);
}

/**
 * Row — the responsive field grid.
 *
 * Column counts follow `docs/calendar-responsive-contract.md` §5: one column
 * on phone, two from `sm`, and the caller's target count from `lg`. Passing
 * the count as a prop rather than a class string keeps the contract in one
 * place instead of scattered across every section.
 */
export function Row({ cols = 3, children }) {
	const lg = cols >= 4 ? 'lg:grid-cols-4' : cols === 3 ? 'lg:grid-cols-3' : 'lg:grid-cols-2';
	return <div className={`grid grid-cols-1 sm:grid-cols-2 ${lg} gap-3 sm:gap-4`}>{children}</div>;
}

export default SectionCard;
